const token =
  'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhcmlvbi1zZXJ2aWNlcy1sb2dnaW5nIiwiaXNzIjoic3VucmlzZS1zZXJ2aWNlcy1sb2dnaW5nIiwiaWF0IjoxNTE2MjM5MDIyfQ.8TcRJEw3zLSfqQOnmiBuYQKNoxDvP9p00Bl0xziZRs0';
export default token;
